import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from './../../../../environments/environment';
import { OperationCostSetting } from './../../_models/financials/operationCostSetting';

@Injectable()
export class OperationCostSettingService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getList(): Observable<OperationCostSetting[]> {
    return this.http.get<OperationCostSetting[]>(
      `${this.apiBaseUrl}api/private/v1/financial/operationCostSettings`
    );
  }

  get(id: number): Observable<OperationCostSetting> {
    return this.http.get<OperationCostSetting>(
      `${this.apiBaseUrl}api/private/v1/financial/operationCostSettings/${id}`
    );
  }

  save(operationCostSettingItem: OperationCostSetting): Observable<OperationCostSetting> {
    const operationCostSetting = { ...operationCostSettingItem };
    // Rimuovi campi non necessari
    delete operationCostSetting.lastUpdated;
    delete operationCostSetting.dateCreated;

    // Aggiungi companyId se presente
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    operationCostSetting.companyId = companySelected ? companySelected.id : null;

    // Se l'utente è presente, prendi solo l'ID
    if (operationCostSetting.user && operationCostSetting.user.id) {
      operationCostSetting.user = { id: operationCostSetting.user.id };
    }

    // Se c'è un ID, esegui PUT, altrimenti POST
    if (operationCostSetting.id) {
      return this.http.put<OperationCostSetting>(
        `${this.apiBaseUrl}api/private/v1/financial/operationCostSettings/${operationCostSetting.id}`,
        operationCostSetting
      );
    } else {
      return this.http.post<OperationCostSetting>(
        `${this.apiBaseUrl}api/private/v1/financial/operationCostSettings/`,
        operationCostSetting
      );
    }
  }

  delete(operationCostSetting: OperationCostSetting): Observable<OperationCostSetting> {
    return this.http
      .delete<void>(
        `${this.apiBaseUrl}api/private/v1/financial/operationCostSettings/${operationCostSetting.id}`
      )
      .pipe(
        map(() => {
          return { id: operationCostSetting.id } as OperationCostSetting;
        })
      );
  }
}
